/* Content for the BackScratch project card */
export const HIGHLIGHTS = [
    "Startup Strategy & Consulting",
    "Cross-Disciplinary Communication & Collaboration",
    "Cost Analysis & Financial Planning",
    "Real-time Problem Solving",
    "Full-Stack Web Development & Deployment",
];

export const CONTENT = {
    subtitle: "I scratch yours, you scratch mine.",
    date: "2026 – Present",
};
